import { madeforyouUrl } from '../../spa/Utils/LocalizedUrls';

export const MADE_FOR_YOU_BASE_URL = `/${madeforyouUrl()}`;

// Max betcards per page on the homepage widget
export const PER_PAGE_COUNT = 3;

export const MADE_FOR_YOU_WIDGET_TYPE_MAIN = 'MAIN_PAGE_WIDGET';
export const MADE_FOR_YOU_WIDGET_TYPE_HOME = 'HOME_PAGE_WIDGET';

export const MADE_FOR_YOU_WON_TYPE = 'won';
export const MADE_FOR_YOU_BACKED_TYPE = 'backed';
export const MADE_FOR_YOU_FOR_TODAY_TYPE = 'fortoday';
export const MADE_FOR_YOU_TYPES = [
    MADE_FOR_YOU_WON_TYPE,
    MADE_FOR_YOU_BACKED_TYPE,
    MADE_FOR_YOU_FOR_TODAY_TYPE,
];

export const MADE_FOR_YOU_GA_COMPONENT_MAIN_TYPES = new Map([
    [MADE_FOR_YOU_WON_TYPE, 'mfy-page-won'],
    [MADE_FOR_YOU_BACKED_TYPE, 'mfy-page-backed'],
    [MADE_FOR_YOU_FOR_TODAY_TYPE, 'mfy-page-fortoday'],
]);

export const MADE_FOR_YOU_GA_COMPONENT_HOME_TYPES = new Map([
    [MADE_FOR_YOU_WON_TYPE, 'mfy-widget-won-home'],
    [MADE_FOR_YOU_BACKED_TYPE, 'mfy-widget-backed-home'],
    [MADE_FOR_YOU_FOR_TODAY_TYPE, 'mfy-widget-fortoday-home'],
]);

export const I18N_PREFIX = 'madeforyou';

export const I18N_MADE_FOR_YOU_WON_TEXT = `${I18N_PREFIX}.recently_won`;
export const I18N_MADE_FOR_YOU_BACKED_TEXT = `${I18N_PREFIX}.recently_backed`;
export const I18N_MADE_FOR_YOU_FOR_TODAY_TEXT = `${I18N_PREFIX}.for_today`;
export const I18N_MADE_FOR_YOU_LOGIN_TO_SEE_TEXT = `${I18N_PREFIX}.login_to_see`;
export const I18N_MADE_FOR_YOU_NO_RECOMMENDED_TEXT = `${I18N_PREFIX}.no_recommended_text`;
export const I18N_MADE_FOR_YOU_ALL_ALL_TEXT = `${I18N_PREFIX}.add_all`;
export const I18N_MADE_FOR_YOU_PREV = `${I18N_PREFIX}.previous`;
export const I18N_MADE_FOR_YOU_NEXT = `${I18N_PREFIX}.next`;

export const I18N_MADE_FOR_YOU_YOU_WON_LONG = `${I18N_PREFIX}.you_won_long`;
export const I18N_MADE_FOR_YOU_YOU_BACKED_LONG = `${I18N_PREFIX}.you_backed_long`;
export const I18N_MADE_FOR_YOU_FOR_TODAY_LONG = `${I18N_PREFIX}.for_today_long`;
export const I18N_MADE_FOR_YOU = `${I18N_PREFIX}.made_for_you`;
export const I18N_MADE_FOR_YOU_BLURB_MAP = {
    [MADE_FOR_YOU_WON_TYPE]: I18N_MADE_FOR_YOU_YOU_WON_LONG,
    [MADE_FOR_YOU_BACKED_TYPE]: I18N_MADE_FOR_YOU_YOU_BACKED_LONG,
    [MADE_FOR_YOU_FOR_TODAY_TYPE]: I18N_MADE_FOR_YOU_FOR_TODAY_LONG,
};

export const I18N_MADE_FOR_YOU_TYPES_MAP = {
    [MADE_FOR_YOU_WON_TYPE]: I18N_MADE_FOR_YOU_WON_TEXT,
    [MADE_FOR_YOU_BACKED_TYPE]: I18N_MADE_FOR_YOU_BACKED_TEXT,
    [MADE_FOR_YOU_FOR_TODAY_TYPE]: I18N_MADE_FOR_YOU_FOR_TODAY_TEXT,
};

export const MADE_FOR_YOU_GTM_HOMEPAGE = 'homepage';
export const MADE_FOR_YOU_GTM_MADE_FOR_YOU = 'made-for-you';
const MADE_FOR_YOU_GTM_HOMEPAGE_WON_TYPE = `${MADE_FOR_YOU_GTM_MADE_FOR_YOU}-recwon`;
const MADE_FOR_YOU_GTM_HOMEPAGE_BACKED_TYPE = `${MADE_FOR_YOU_GTM_MADE_FOR_YOU}-recback`;
const MADE_FOR_YOU_GTM_HOMEPAGE_FOR_TODAY_TYPE = `${MADE_FOR_YOU_GTM_MADE_FOR_YOU}-fortoday`;
const MADE_FOR_YOU_GTM_WON_TYPE = 'won';
const MADE_FOR_YOU_GTM_BACKED_TYPE = 'backed';
const MADE_FOR_YOU_GTM_FOR_TODAY_TYPE = 'for-today';

export const MADE_FOR_YOU_GTM_HOMEPAGE_MAP = {
    [MADE_FOR_YOU_WON_TYPE]: MADE_FOR_YOU_GTM_HOMEPAGE_WON_TYPE,
    [MADE_FOR_YOU_BACKED_TYPE]: MADE_FOR_YOU_GTM_HOMEPAGE_BACKED_TYPE,
    [MADE_FOR_YOU_FOR_TODAY_TYPE]: MADE_FOR_YOU_GTM_HOMEPAGE_FOR_TODAY_TYPE,
};
export const MADE_FOR_YOU_GTM_MADE_FOR_YOU_MAP = {
    [MADE_FOR_YOU_WON_TYPE]: MADE_FOR_YOU_GTM_WON_TYPE,
    [MADE_FOR_YOU_BACKED_TYPE]: MADE_FOR_YOU_GTM_BACKED_TYPE,
    [MADE_FOR_YOU_FOR_TODAY_TYPE]: MADE_FOR_YOU_GTM_FOR_TODAY_TYPE,
};

export const MADE_FOR_YOU_GTM_SEE_ALL = 'see-all';
export const MADE_FOR_YOU_GTM_ADD_ALL_TO_BET_SLIP = 'add-all-to-bet-slip';
export const MADE_FOR_YOU_GTM_PREVIOUS_SELECTIONS = 'previous-selections';
export const MADE_FOR_YOU_GTM_NEXT_SELECTIONS = 'next-selections';
const MADE_FOR_YOU_GTM_SWITCHED_TAB_RECWON = 'switched-tab-recwon';
const MADE_FOR_YOU_GTM_SWITCHED_TAB_RECBACK = 'switched-tab-recback';
const MADE_FOR_YOU_GTM_SWITCHED_TAB_FORTODAY = 'switched-tab-fortoday';

export const MADE_FOR_YOU_GTM_SWITCHED_TAB_MAP = {
    [MADE_FOR_YOU_WON_TYPE]: MADE_FOR_YOU_GTM_SWITCHED_TAB_RECWON,
    [MADE_FOR_YOU_BACKED_TYPE]: MADE_FOR_YOU_GTM_SWITCHED_TAB_RECBACK,
    [MADE_FOR_YOU_FOR_TODAY_TYPE]: MADE_FOR_YOU_GTM_SWITCHED_TAB_FORTODAY,
};

export const WS_HANDLER_COMPONENT_NAME = 'Made_For_You';
